import { render, staticRenderFns } from "./CoozzyHouseUserIcon.vue?vue&type=template&id=d5280d16&scoped=true"
import script from "./CoozzyHouseUserIcon.vue?vue&type=script&lang=js"
export * from "./CoozzyHouseUserIcon.vue?vue&type=script&lang=js"
import style0 from "./CoozzyHouseUserIcon.vue?vue&type=style&index=0&id=d5280d16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5280d16",
  null
  
)

export default component.exports